import { useTranslation } from "react-i18next";
import type { EvalBidDto, SourcingEventV2Dto } from "../../../../autogen/bff-api";
import type { FocusProgress, FocusSubject } from "../../../../common/focus/focusSubject";
import type { FocusSelection } from "../../../../common/focus/useFocusSubjectParam";
import { BidFocusOverlay } from "./BidFocusOverlay";
import { EvaluationFocusActions } from "./EvaluationFocusActions";
import { EvaluationFocusBody } from "./EvaluationFocusBody";

interface Props {
  event: SourcingEventV2Dto;
  bids: EvalBidDto[];
  focus: FocusSelection<EvalBidDto>;
  subjects: FocusSubject[];
  progress: FocusProgress;
}

export const EvaluationFocusOverlay = ({ event, focus, subjects, progress }: Props) => {
  const { t } = useTranslation();
  const active = focus.active;
  const focused = active ? subjects[focus.index] : null;
  if (!active || !focused) return null;

  return (
    <BidFocusOverlay
      eyebrow={String(t("Evaluation review"))}
      subtitle={event.eventData.title}
      subjects={subjects}
      active={focused}
      index={focus.index}
      progress={progress}
      hasPrevious={focus.hasPrevious}
      hasNext={focus.hasNext}
      onSelect={focus.select}
      onPrevious={focus.goPrevious}
      onNext={focus.goNext}
      onClose={focus.close}
      // Keyed per bid: the score editor queues edits by criterion alone, which repeats across bids.
      renderContent={() => <EvaluationFocusBody key={active.bidId} eventId={event.id} bid={active} />}
      renderActions={() => <EvaluationFocusActions key={active.bidId} bid={active} />}
    />
  );
};
